import { db } from '../firebase';
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';

// THE PUBLIC PACK BUY PATH WAS REMOVED 2026-08-18 (card cYdGGTb4kI35hVRGFA4B).
// Gone from this file with it: fetchPacks (the public catalog read), the
// isPackComingSoon / isPackPurchasable date+status gates, packSchedulingNote,
// and the createPackCheckout callable wrapper. Nothing on the site can start a
// pack checkout any more, and the Cloud Function refuses one anyway — it throws
// unless the pack's Firestore status is 'open', and all four docs were flipped
// to 'archived' at deploy.
//
// What survives is deliberate and still in use:
//   - instrumentDisplayLabel — /register renders lesson interests with it.
//   - the three admin reads below — the employee portal's Lesson Pack Purchases
//     page still shows the historical roster, leads and enrollments. Past
//     purchases did not stop existing.
// See the note at the top of pages/Lessons/LessonPacks.js for the business
// reason and for what a summer-2027 restore would need.

// Display-only rename (decided 2026-07-06): customer-facing labels for the
// Piano/Guitar offering read as the full name below. The underlying
// `instrument` value stays 'Piano'/'Guitar' everywhere else (scheduling
// logic, email branching, MMS category matching).
const INSTRUMENT_DISPLAY_LABEL = {
	Piano: 'Intro Piano for the Singer',
	Guitar: 'Intro Guitar for the Singer',
};
export function instrumentDisplayLabel(instrument) {
	return INSTRUMENT_DISPLAY_LABEL[instrument] || instrument;
}

// ── Admin (employee portal) reads ──

// All packs regardless of status (for the management roster).
export async function fetchPacksForAdmin() {
	const q = query(collection(db, 'packs'), orderBy('sortOrder'));
	const snap = await getDocs(q);
	return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// Confirmed/refunded pack enrollments.
export async function fetchPackEnrollments() {
	const q = query(collection(db, 'enrollments'), where('type', '==', 'pack'));
	const snap = await getDocs(q);
	return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// Pack-purchase leads (pending / abandoned / converted intake records).
export async function fetchPackLeads() {
	const q = query(collection(db, 'leads'), where('type', '==', 'pack-purchase'));
	const snap = await getDocs(q);
	return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
